// extracted by mini-css-extract-plugin
module.exports = {"root":"SendButton_root__1nnfr","input":"SendButton_input__3wieS","button":"SendButton_button__2s5L0"};